import { alpha, Theme } from '@mui/material/styles';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

import { colorsPalette, MIDDLE_MARGIN, SMALL_MARGIN } from '../../theme';

const useStyles = (background) =>
  makeStyles((theme: Theme) =>
    createStyles({
      wrapper: {
        paddingTop: 36,
        paddingBottom: 36,
        background: theme.palette.secondary.dark,
        overflowX: 'hidden',
        '&:first-child': {
          marginTop: 76,
        },

        [theme.breakpoints.up('sm')]: {
          paddingTop: 72,
          paddingBottom: 72,
          background:
            background === 'Dark' ? theme.palette.secondary.dark : theme.palette.secondary.light,

          '&:first-child': {
            marginTop: 120,
          },
        },
      },
      container: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      },
      detailsBox: {
        width: '100%',
        [theme.breakpoints.up('md')]: {
          width: `calc(100% + ${SMALL_MARGIN}px)`,
          marginLeft: `-${SMALL_MARGIN / 2}`,
          marginRight: `-${SMALL_MARGIN / 2}`,
          display: 'flex',
        },
      },
      detailBox: {
        width: '100%',
        marginBottom: MIDDLE_MARGIN,
        padding: `0 ${SMALL_MARGIN}px`,
        boxSizing: 'border-box',
        [theme.breakpoints.up('md')]: {
          width: 'calc(100/3%)',
          marginBottom: 0,
        },
        '&:last-child': {
          marginBottom: 0,
        },
        '&:not(:last-child)': {
          [theme.breakpoints.up('md')]: {
            borderRight: '1px solid ' + alpha(colorsPalette.white, 0.33),
          },
        },
      },
      detailBoxContent: {
        flex: 1,
        marginTop: 0,
        [theme.breakpoints.up('sm')]: {
          marginTop: SMALL_MARGIN,
        },
      },
      detailBoxImage: {
        display: 'flex',
        alignItems: 'center',
        width: 40,
        height: 40,
        margin: '0 auto 8px',
        [theme.breakpoints.up('sm')]: {
          width: 64,
          height: 64,
        },
        '& img': {
          maxWidth: '100%',
          maxHeight: '100%',
        },
      },
      detailBoxTitle: {
        marginBottom: 4,
        fontSize: 24,
        lineHeight: '22px',
        textAlign: 'center',
        [theme.breakpoints.up('md')]: {
          marginBottom: 11,
          fontSize: 28,
          lineHeight: '31px',
        },
      },
      detailBoxDescription: {
        fontSize: 16,
        lineHeight: '1.5',
        color: colorsPalette.gray,
        wordBreak: 'break-word',
        textAlign: 'center',
        '& p, & strong': {
          margin: 0,
          fontSize: 'inherit',
          lineHeight: 'inherit',
        },
        '& a': {
          color: colorsPalette.blue,
          fontWeight: 'bold',
          '&:hover': {
            textDecoration: 'underline',
          },
        },
        [theme.breakpoints.up('sm')]: {
          fontSize: 18,
          lineHeight: '1.5',
          color: colorsPalette.gray,
          '& p, & strong': {
            margin: 0,
            fontSize: 'inherit',
            lineHeight: 'inherit',
          },
        },
      },
    }),
  );
export default useStyles;
